/**
 * Простые типы для синхронизации рисунков между клиентом и психологом
 * Подход взят из livepaint: используем unit coordinates (0-1) для размерной независимости
 */

export interface Line {
  x1: number;
  y1: number;
  x2: number;
  y2: number;
  tool?: 'pencil' | 'brush-thin' | 'brush-medium' | 'brush-thick' | 'brush-extra' | 'eraser';
  color?: string;
}

export function pixelToUnit(x: number, y: number, width: number, height: number): { x: number; y: number } {
  return {
    x: Math.max(0, Math.min(1, x / width)),
    y: Math.max(0, Math.min(1, y / height)),
  };
}

export function unitToPixel(x: number, y: number, width: number, height: number): { x: number; y: number } {
  return {
    x: x * width,
    y: y * height,
  };
}